import { useEffect } from 'react';
import { navigate } from "@reach/router"

const ApplicationsPage = () => {
  useEffect(() => {
    navigate('/');
  }, []);
  return null;
};

export default ApplicationsPage;